export const formatAbnOrAcn = (raw) => {
  if (!raw) {
    return raw;
  }

  const trimmed = raw.replace(/ /g, '');

  // ABN - ## ### ### ###
  if (trimmed.length === 11) {
    return `${trimmed.substring(0, 2)} ${trimmed.substring(2, 5)} ${trimmed.substring(5, 8)} ${trimmed.substring(8)}`;
  }

  // ACN - ### ### ###
  if (trimmed.length === 9) {
    return `${trimmed.substring(0, 3)} ${trimmed.substring(3, 6)} ${trimmed.substring(6)}`;
  }

  return raw;
};

export default {
  formatAbnOrAcn,
};
